import { RouteLocationNormalized } from 'vue-router';

import { isPublicRoute } from '@/routerAccess';
import { useAuthStore } from '@/stores/auth';
import { useTenantStore } from '@/stores/tenant';

/* ------------------------------------------------------------
 * Check if the user has the required permission
 * ------------------------------------------------------------ */
export default function requiredPermissionGuard(to: RouteLocationNormalized) {
    const authStore = useAuthStore();
    const tenantStore = useTenantStore();

    if (isPublicRoute(to) || !authStore.isAuthenticated) {
        return true;
    }

    switch (to.meta.requiredPermission) {
        case 'admin':
            if (!tenantStore.tenantAdmin) {
                return '/unauthorized';
            }
            break;
        case 'elqano':
            if (!tenantStore.tenantElqano) {
                return '/unauthorized';
            }
            break;
        case 'elqano_admin':
            if (!tenantStore.tenantElqano || !tenantStore.tenantAdmin) {
                return '/unauthorized';
            }
            break;
        default:
            break;
    }

    return true;
}
